(function () {
    new themegoal.helpers.Responsive();
    new TG_ProductCardColorSwatch();

    let windowWidth = window.innerWidth;

    window.addEventListener('resize', function () {
        let newWidth = window.innerWidth;

        if (newWidth === windowWidth) {
            return;
        }

        windowWidth = newWidth;

        let headerSection = document.getElementById('Header');

        if (headerSection) {
            document.documentElement.style.setProperty('--tg-header-height', headerSection.offsetHeight + 'px');
            document.documentElement.style.setProperty('--tg-header-logo-width', document.querySelector('.Header__LogoWrapper').offsetWidth + 'px');
        }
    });


    if( document.getElementById('SearchDrawer'))
    new TG_SearchDrawer();

})();